export default function isPrimitive(value) {
    return (typeof value === 'boolean' ||
        typeof value === 'number' ||
        typeof value === 'string');
}
//# sourceMappingURL=is-primitive.js.map